export default __webpack_public_path__ + "static/media/profile-user.1fdff30b.svg";